import { Box } from '@rebass/grid';
import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';
import Body from '../primitive/Body';

interface Props {
    name: string;
    options: {
        key: string;
        label: ReactNode;
    }[];
    active: string;
    setActive: (key: string) => void;
}
const ToggleSwitchWithText: FC<React.PropsWithChildren<Props>> = ({ options, name, active, setActive, ...props }) => {
    const firstOption = options[0];
    const secondOption = options[1];
    const [idSuffix] = useState([...Array(12)].map(() => Math.floor(Math.random() * 16).toString(16)).join(''));

    return (
        <ToggleSwitch {...props}>
            <Box p={2}>
                <Wrapper>
                    <div>
                        <RadioButton
                            type="radio"
                            value={firstOption.key}
                            name={name}
                            id={firstOption.key + idSuffix}
                            checked={firstOption.key === active}
                            onChange={() => setActive(firstOption.key)}
                        />
                        <Label htmlFor={firstOption.key + idSuffix}>
                            <StyledBody variant="small">{firstOption.label}</StyledBody>
                        </Label>
                    </div>
                    <div>
                        <RadioButton
                            type="radio"
                            value={secondOption.key}
                            name={name}
                            id={secondOption.key + idSuffix}
                            checked={secondOption.key === active}
                            onChange={() => {
                                setActive(secondOption.key);
                            }}
                        />
                        <Label htmlFor={secondOption.key + idSuffix}>
                            <StyledBody variant="small">{secondOption.label}</StyledBody>
                        </Label>
                    </div>
                </Wrapper>
            </Box>
        </ToggleSwitch>
    );
};

export default ToggleSwitchWithText;

const ToggleSwitch = styled.div`
    background-color: ${({ theme }) => theme.colors.neutral[5]};
    border-radius: 10rem;
    border: 1px solid ${({ theme }) => theme.colors.neutral[20]};
    display: inline-block;
`;

const RadioButton = styled.input`
    display: none;
    cursor: pointer;

    + label p {
        border: 1px solid transparent;
    }

    &:checked + label p {
        transition: all 0.2s ease-in-out;
        background-color: ${({ theme }) => theme.colors.neutral[0]};
        border: 1px solid ${({ theme }) => theme.colors.neutral[40]};
        box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
    }
`;

const StyledBody = styled(Body)`
    border-radius: 10rem;
    padding: 0.8rem 2.4rem;
    font-weight: 600;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueriesValues.s}px) {
        padding: 0.8rem 1.8rem;
    }
`;
const Wrapper = styled.div`
    display: flex;
`;

const Label = styled.label`
    margin-bottom: 0;
    &:hover {
        cursor: pointer;
    }
`;
